const CONTENT_HEIGHT = 450;
const CONTENT_WIDTH = 380;

export const tooltipDirectionMap = {
  bottomRight: ({ bottom, right }) => (
    window.innerHeight - bottom > CONTENT_HEIGHT && window.innerWidth - right > CONTENT_WIDTH
  ),

  bottomLeft: ({ bottom, left }) => (
    window.innerHeight - bottom > CONTENT_HEIGHT && left > CONTENT_WIDTH
  ),

  upRight: ({ top, right }) => (
    top > CONTENT_HEIGHT && window.innerWidth - right > CONTENT_WIDTH
  ),

  upLeft: ({ top, left }) => (
    top > CONTENT_HEIGHT && left > CONTENT_WIDTH
  ),
};
